import React from 'react';
import { Tooltip } from 'freemium-ui';
import { t } from 'i18next';
import { FilterViewContainer } from 'routes/screens/contacts/components/FilterViews/styles';
import Icon from 'shared/components/Icon';
import { FilterViewType } from 'shared/types';

type FilterViewActionProps = {
  onClearFilterView: (selectedFilter: FilterViewType) => void;
  onSave: (filterViewName: string, isCreate?: boolean) => void;
  selectedFilter: FilterViewType;
  filterViews: FilterViewType[];
  setAnchorEl: (value: any) => void;
};

const FilterViewActions = (props: FilterViewActionProps) => {
  const {
    onClearFilterView,
    onSave,
    selectedFilter,
    filterViews,
    setAnchorEl,
  } = props;
  const saveFilterViewRef = React.useRef<HTMLDivElement>(null);

  return (
    <FilterViewContainer>
      {filterViews?.filter((filter) => selectedFilter?.name == filter.name)
        ?.length > 0 && (
        <Tooltip
          label={`${t('forms.filter_view.update_view')}`}
          position="bottom"
        >
          <Icon
            className="filter-view tick"
            width="13"
            height="13"
            glyph="black-tick"
            onClick={() => {
              onSave(selectedFilter.name);
            }}
          />
        </Tooltip>
      )}
      <div ref={saveFilterViewRef}>
        <Tooltip
          label={`${t('forms.filter_view.save_view')}`}
          position="bottom"
        >
          <Icon
            className="filter-view tick"
            id="filter-view"
            width="13"
            height="13"
            glyph="black-tick-v2"
            onClick={(e) => setAnchorEl?.(e.currentTarget)}
            aria-describedby="filter-view-popover"
          />
        </Tooltip>
      </div>
      <Tooltip
        label={`${t('forms.filter_view.discard_view')}`}
        position="bottom"
      >
        <Icon
          className="filter-view close"
          width="10"
          height="10"
          glyph="close"
          onClick={() => onClearFilterView(selectedFilter)}
        />
      </Tooltip>
    </FilterViewContainer>
  );
};

export default FilterViewActions;
